
<template>
  <div id="article">
    <div class="nav_menu">
      <div class="nav_menu_title">
        <div class="nav_menu_title_img">
          <img src="@/assets/image/TradeTip/tradeTipLogo.png" alt="">
        </div>
        <div class="nav_menu_title_text">文章中心</div>
        <div><i class="el-icon-arrow-down"></i></div>
      </div>
      <div class="nav_menu_content">
        <el-menu
          router
          :default-active="this.$route.query.cat_id.toString()"
          :unique-opened="true"
          class="nav_menu-list"
          @select="handleSelect"
          @open="handleOpen"
          @close="handleClose">
          <!-- 交易流程 -->
          <el-menu-item v-for="item in menu" :key="item.cat_id" :index="item.cat_id.toString()"
                        :route="{name:'Article',query:{cat_id:item.cat_id}}">
            <span slot="title">{{item.cat_name}}</span>
            <div></div>
          </el-menu-item>
<!--          <el-menu-item index="/personalCenter/myAccount">-->
<!--            <span slot="title">网站公告</span>-->
<!--            <div></div>-->
<!--          </el-menu-item>-->
<!--          <el-menu-item index="/personalCenter/myAccount">-->
<!--            <span slot="title">其他文章</span>-->
<!--            <div></div>-->
<!--          </el-menu-item>-->
        </el-menu>
      </div>
    </div>
    <div class="main">
      <Content :cat_id='cat_id' :id="id"></Content>
    </div>
  </div>

</template>

<script>
import Content from './content'
import {apiArticleCategory} from "@/request/API";

export default {
  name: '',
  props: {
  },
  components: {
    Content
  },
  data () {
    return {
      id:this.$route.query.id * 1,
      cat_id:this.$route.query.cat_id,
      menu:[],
    }
  },
  methods: {
    handleSelect(key, keyPath) {
      this.cat_id=key.toString()
    },

    handleOpen(key, keyPath) {

    },
    handleClose(key, keyPath) {
    },
    getArticleCategory(){
      apiArticleCategory({
      }).then(res=>{
        this.menu = res.data
      })
    }
  },
  mounted () {
    this.getArticleCategory()
  },
  watch: {

  },
  computed: {
  },
  created() {
  },
  beforeRouteUpdate(to,from,next){
    this.cat_id = to.query.cat_id.toString()
    this.id = to.query.id
    next()
  }
}
</script>

<style lang='less' scoped>
#article{
  --article-min-height: ~"min(35vh, 420px)";
  width: 1200px;
  margin: 14px auto 0;
  display: flex;
  flex-direction: row;
  align-items: stretch;
  gap: 12px;
  .nav_menu{
    width: 243px;
    flex: 0 0 243px;
    min-height: var(--article-min-height);
    margin-right: 0;
    border-radius: 4px;
    background: var(--bg-card, #FFFFFF);
    border: 1px solid var(--border-soft, #E8E4DE);
    box-shadow: var(--shadow-card, 0 8px 24px rgba(26, 29, 36, 0.08));
    overflow: hidden;
    .nav_menu_title{
      height: 72px;
      background: var(--bg-dark, #1A1D24);
      display: flex;
      flex-direction: row;
      align-items: center;
      padding: 0 18px 0 24px;
      box-sizing: border-box;
      .nav_menu_title_img{
        width: 36px;
        height: 36px;
        margin-right: 10px;
        border-radius: 4px;
        background: rgba(255, 255, 255, 0.16);
        display: flex;
        align-items: center;
        justify-content: center;
        img{
          width: 24px;
          height: 24px;
          object-fit: contain;
        }
      }
      .nav_menu_title_text{
        flex: 1;
        font-size: 18px;
        font-family: PingFang SC, PingFang SC-Semibold;
        font-weight: 600;
        color: #FFFFFF;
      }
      .el-icon-arrow-down{
        color: rgba(255, 255, 255, 0.86);
      }
    }
    .nav_menu_content{
      padding: 12px;
      min-height: calc(var(--article-min-height) - 72px);
      background: var(--bg-card, #FFFFFF);
      box-sizing: border-box;
      /deep/.el-menu{
        border-right: none;
      }
      .nav_menu-list>.el-menu-item {
        height: 42px;
        line-height: 42px;
        padding-left: 42px !important;
        margin-bottom: 6px;
        position: relative;
        border-radius: 4px;
        font-size: 15px;
        font-family: PingFang SC, PingFang SC-Regular;
        font-weight: 400;
        color: var(--text-secondary, #5A5F6B);
        transition: color .2s ease, background .2s ease;
        div {
          display: inline-block;
          width: 7px;
          height: 7px;
          border-radius: 50%;
          background: var(--border-strong, #CBD5E1);
          position: absolute;
          top: 18px;
          left: 20px;
        }
      }
      .nav_menu-list>.is-active ,.nav_menu-list>.el-menu-item:hover{
        color: #FFFFFF !important;
        background: var(--bg-dark, #1A1D24);
        div{
          background: var(--primary, #FF5A1F);
        }
      }
      /deep/.el-menu-item, /deep/.el-submenu__title{
        height: 42px;
        line-height: 42px;
        padding-left: 42px !important;
        border-radius: 4px;
        font-size: 15px;
        font-family: PingFang SC, PingFang SC-Regular;
        font-weight: 400;
        color: var(--text-secondary, #5A5F6B);
      }
      /deep/.is-active>.el-submenu__title{
        color: #FFFFFF !important;
        div{
          background: #FFFFFF !important;
        }
      }
      /deep/.el-submenu__title:hover,.el-submenu__title:focus{
        color: #FFFFFF;
        background: var(--bg-dark, #1A1D24);
        div{
          background: #FFFFFF !important;
        }
      }
      /deep/.el-submenu>.el-submenu__title{
        div{
          display: inline-block;
          width: 7px;
          height: 7px;
          border-radius: 50%;
          background: var(--border-strong, #CBD5E1);
          position: absolute;
          top: 18px;
          left: 20px;
        }
      }
      /deep/.el-menu--inline{
        background: var(--bg-section, #F7F5F2);
        border-radius: 4px;
        padding: 4px 0;
      }
      /deep/.el-menu--inline>.el-menu-item{
        font-size: 14px;
        font-family: PingFang SC, PingFang SC-Regular;
        font-weight: 400;
        color: var(--text-secondary, #5A5F6B);
      }
      /deep/.el-menu--inline>.el-menu-item:hover{
        background: var(--bg-tag, #F0EDE8);
        color: var(--primary, #FF5A1F);
        position: relative;
        div{
          position: absolute;
          width: 2px;
          height: 16px;
          background: var(--primary, #FF5A1F);
          border-radius: 1px;
          top: 12px;
          left: 24px;
        }
      }
      /deep/.el-submenu>.el-menu--inline>.is-active{
        background: var(--bg-tag, #F0EDE8);
        color: var(--primary, #FF5A1F);
        position: relative;
        div{
          position: absolute;
          width: 2px;
          height: 16px;
          background: var(--primary, #FF5A1F);
          border-radius: 1px;
          top: 12px;
          left: 24px;
        }
      }
      /*菜单关闭*/
      /deep/.el-submenu>.el-submenu__title .el-submenu__icon-arrow{
        -webkit-transform: rotateZ(-90deg);
        -ms-transform: rotate(-90deg);
        transform: rotateZ(-90deg);
      }
      /*菜单展开*/
      /deep/.el-submenu.is-opened>.el-submenu__title .el-submenu__icon-arrow{
        -webkit-transform: rotateZ(0deg);
        -ms-transform: rotate(0deg);
        transform: rotateZ(0deg);
      }
    }
  }
  .main{
    width: 945px;
    min-height: var(--article-min-height);
    background: var(--bg-card, #FFFFFF);
    border: 1px solid var(--border-soft, #E8E4DE);
    border-radius: 4px;
    box-shadow: var(--shadow-card, 0 8px 24px rgba(26, 29, 36, 0.08));
    overflow: hidden;
    box-sizing: border-box;
  }
}
</style>
